<template>
  <DefButtonPrimary
    class="def-buy"
    :class="{ 'in-basket': basketStore.inBasket(id), 'def-buy-small': !$slots?.default }"
    :disabled="disabled || isRequestSend"
    @click="handlerBuy"
  >
    <!-- product in basket -->
    <svg v-if="basketStore.inBasket(id)" class="def-buy__icon">
      <use xlink:href="#svg-check"></use>
    </svg>
    <svg v-else class="def-buy__icon"><use xlink:href="#svg-basket"></use></svg>

    <slot v-if="basketStore.inBasket(id)" name="inBasket" />
    <!-- add product to basket -->
    <slot v-else />
  </DefButtonPrimary>
</template>

<script>
import gsap from 'gsap';

import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';
import useBasketModal from '@use/useBasketModal';
import { useBasketStore } from '@/storePinia/stores/basket';

import Analytics from '@/utils/Analytics/Analytics';
import { getBuyPayload } from '@/utils/getBuyPayload';
import { scrollPageTo } from '@/utils/helpers';

export default {
  name: 'DefBuy',
  components: {
    DefButtonPrimary,
  },
  props: {
    result: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      isRequestSend: false,
      modal: useModal(),
      basketModal: useBasketModal(),
      basketStore: useBasketStore(),
    };
  },
  computed: {
    id() {
      return this.result?.offer?.id || this.result?.id;
    },
  },
  async mounted() {
    if (this.basketStore.count !== this.basketStore.items.length) {
      await this.basketStore.getData();
    }
  },
  methods: {
    createAnimation() {
      try {
        const div = document.createElement('div');
        div.classList.add('buy-animation');
        div.style.backgroundImage = `url(${this.result.picture.src})`;
        div.style.zIndex = 2001;

        const baskets = document.querySelectorAll('.small-basket-control');

        if (!baskets.length) return;

        const smallBasket = baskets.length === 2 ? baskets[1] : baskets[0];
        const rect = smallBasket.getBoundingClientRect();

        document.body.appendChild(div);

        gsap
          .timeline({
            defaults: {
              duration: 1,
            },
            onComplete() {
              div.remove();
            },
          })
          .to(div, {
            top: innerHeight / 2,
            left: innerWidth / 2,
            width: 100,
            height: 100,
            xPercent: -50,
            yPercent: -100,
            ease: 'power1.in',
          })
          .to(div, {
            top: rect.top,
            left: rect.left,
            width: 50,
            height: 50,
            borderWidth: 1,
            xPercent: -20,
            yPercent: -20,
            ease: 'none',
          });
      } catch (err) {
        console.error(err);
      }
    },
    async handlerBuy() {
      if (!this.basketStore.inBasket(this.id)) {
        this.isRequestSend = true;
        this.createAnimation();

        const payload = getBuyPayload(this.result);

        await this.basketStore.add(payload);
        Analytics.addToBasket(this.result);
        scrollPageTo(0);
        this.isRequestSend = false;
        this.$emit('added');
      } else {
        await this.modal.hide();
        this.basketModal.open();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.def-buy {
  display: flex;
  gap: 4px;
  &__icon {
    display: block;
    width: 20px;
    height: 20px;
    fill: currentColor;
    flex-shrink: 0;
  }
}
.def-buy-small {
  padding: 0 8px;
  height: 40px;
  min-width: 40px;
}
</style>
